import styled, { css } from "styled-components";

export const Container = styled.div`
  font-family: "Open Sans", sans-serif;
  max-width: 26rem;
  color: #757575;

  input {
    display: none;
  }
`;
export const FilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  border-radius: 0 0 8px 8px;
  border: 1px solid #d9d9d9;

  div {
    border-top: 1px solid #d9d9d9;
    padding: 0.5rem 0.25rem;

    &:first-child {
      border-top: none;
    }
  }

  button {
    cursor: pointer;
    background-color: transparent;
    border: none;
  }
`;
export const LabelContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !["hasFiles"].includes(prop),
})<{ hasFiles: boolean }>`
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  cursor: pointer;

  .background {
    background-color: #d9d9d9;
  }

  button {
    background: transparent;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    padding: 0.25rem;
  }

  span {
    text-align: center;
    font-size: 14px;
    color: #212121;
  }

  img {
    border-radius: 8px;
    padding: 0.375rem 0.3rem;
  }

  ${(props) =>
    props.hasFiles &&
    css`
      border-bottom: 0;
      border-radius: 8px 8px 0 0;
    `}
`;

export const DragOnDropLabel = styled.div`
  margin-bottom: 2rem;
  padding: 0.25rem 1rem;
  width: 100%;
  min-width: 322px;
  max-width: 354px;
  min-height: 54px;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  background: #f5f5f5;
  font-family: "Open Sans", sans-serif;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .remove-button {
    margin: 0 auto;
    font-size: 12px;
    color: #757575;
    text-decoration: underline;
    cursor: pointer;
    border: none;
    background: none;
    padding: 0;
  }

  .remove-button:hover {
    text-decoration: none;
  }

  .underline {
    display: inline-block;
    text-decoration: underline;
    cursor: pointer;
  }

  .underline:hover {
    text-decoration: none;
  }

  .container {
    width: 100%;
    height: 54px;
    vertical-align: middle;
    justify-content: center;
    display: grid;

    img {
      display: flex;
      margin: 33px auto 17px auto;
      width: 38px;
    }

    span {
      font-size: 14px;
      position: relative;
    }

    p {
      margin: 0px auto 0px auto;
      font-size: 12px;
      color: #757575;
    }
    p:hover {
      margin: 0px auto 0px auto;
      font-size: 12px;
      color: #757575;
    }

    @media (max-width: 600px) {
      width: 100%;
      height: 100%;

      div img {
        display: flex;
        margin: 9px auto 17px auto;
      }
    }
  }
`;

export const TextContainer = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%; // Assegure-se que este seja o único elemento flexível no pai, se necessário
`;

export const Item = styled.div`
  display: flex;
  gap: 1rem;
  margin: 0.5rem 0;
  align-items: center;
  justify-content: flex-start;
  max-width: 354px;

  button {
    outline: none;
    border: none;
    border-radius: 8px;
    background-color: #e0e0e0;
    color: #333;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }

  button:hover {
    background-color: #e0e0e0;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  }

  button:active {
    background-color: #d4d4d4;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    transform: scale(0.98);
  }

  button:focus {
    outline: 2px solid #333;
    outline-offset: 2px;
  }
`;
